export default __webpack_public_path__ + "static/media/star.77476801.svg";